
<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
  <b-modal
      :id="id"
      modal-class="giga-modal"
      dialog-class="modal-lg"
      content-class="text-center pb-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      lazy
  >



    <div class="gigawhat-modal">
      <div class="modal-heading">
        <h2 class="modal-title" v-text="title"></h2>
      </div>

        <agence-infos
            :$v="$v"
            :agenceForm="agenceForm"
            :cities="cities"
            :agencyNotFound = "agencyNotFound"
            :siretAlreadyExists="siretAlreadyExists"
            @updateSiretExists="siretAlreadyExists = $event"
            @onSiretChange="fetchAgencyInfosBySiret"
            @fetchCitiesByPostalCode="fetchCitiesByPostalCode"
        ></agence-infos>

      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button class="giga-blue_outlined_button no-icon" @click="closeModalAgence()">Quitter</button>
          </div>
        </div>
        <div class="half-footer right-content">
          <div class="giga-button">
            <button :disabled="$v.agenceForm.$invalid" class="giga-green_button no-icon" @click="saveAgence()">Terminer</button>
          </div>
        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>

import {mapGetters, mapMutations} from 'vuex';
import {required, requiredIf, email} from "vuelidate/lib/validators";
import {constants} from "@/shared/constants";
import AgenceInfos from "@/views/Agences/AgenceInfos.vue";
import {agenceService} from "@/views/service/agence.service";

export default {
  name: "AgenceModal",
  props: ['id','title','agenceForm' ,'loader', 'isReadOnly'],
  components: {AgenceInfos},
  agenceForm: {
    siret: '',
    raisonSocial: '',
    address: '',
    city: '',
    postalCode: '',
    isEnabled: true,
  },
  data(){
    return{
      cities:[],
      agencyNotFound: false,
      siretAlreadyExists: false,
    }
  },
  validations: {
      agenceForm: {
        siret: {
          required,
          customValidation: function(value) {
            const siretIsValid = this.siretIsValid;
            return siretIsValid;
          }
        },
        raisonSocial: {
          required
        },
        address: {
          required
        },
        postalCode: {
          required,
          customValidationPostalCode: function (value) {
            return !value || this.isPostalCodeValid(value);
          },
        },
        city: {
          required
        }
      }
  },
  computed:{
    ...mapGetters('user', {currentTab: 'getCurrentTab'}),
    siretIsValid() {
      return this.checkLuhn(this.$v.agenceForm.siret.$model);
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      this.$v.$reset();
    })

  },
  methods:{
    checkLuhn(siret) {
      let nDigits = siret.length;
      let nSum = 0;
      let isSecond = false;

      for (let i = nDigits - 1; i >= 0; i--) {
        let d = parseInt(siret.charAt(i), 10);

        if (isSecond) {
          d = d * 2;
        }

        nSum += Math.floor(d / 10);
        nSum += d % 10;

        isSecond = !isSecond;
        if (siret.length !== 14) {
          return false;
        }
      }
      return nSum % 10 === 0;
    },
    isPostalCodeValid(postalCode) {
      return /^[0-9]{5}$/.test(postalCode);
    },
    fetchCitiesByPostalCode(postalCode) {
      if (!postalCode) return;

      agenceService.fetchCitiesByPostalCode(postalCode).then(cities => {
        this.cities = cities;
        this.$nextTick(() => {
          if (!this.agenceForm.city) {
            this.agenceForm.city = '';
          }
        });
      });
    },
    fetchAgencyInfosBySiret(){
      agenceService.fetchAgencyInfosBySiret(this.$v.agenceForm.siret.$model).then(async agenceInfos => {
        if (agenceInfos.raisonSociale == null && agenceInfos.numeroVoie == null && agenceInfos.typeVoie == null && agenceInfos.libelleVoie == null && agenceInfos.postalCodeSiret == null ) {
          this.agencyNotFound = true;
          this.siretAlreadyExists = false;
        } else {
          const raisonSociale = agenceInfos.raisonSociale === null ? '' : agenceInfos.raisonSociale
          const numeroVoie = agenceInfos.numeroVoie === null ? '' : agenceInfos.numeroVoie
          const typeVoie = agenceInfos.typeVoie === null ? '' : agenceInfos.typeVoie
          const libelleVoie = agenceInfos.libelleVoie === null ? '' : agenceInfos.libelleVoie
          const postalCodeSiret = agenceInfos.postalCodeSiret === null ? '' : agenceInfos.postalCodeSiret
          const siret = this.agenceForm.siret;
            try {
              this.siretAlreadyExists = await agenceService.checkSiretExists(siret) || false;
            } catch (error) {
              this.siretAlreadyExists = false;
            }

          this.$v.agenceForm.raisonSocial.$model = raisonSociale;
          this.$v.agenceForm.address.$model = `${numeroVoie} ${typeVoie} ${libelleVoie}`;
          this.$v.agenceForm.postalCode.$model = postalCodeSiret;
          this.agenceForm.postalCode=postalCodeSiret;
        }
      });
    },
    saveAgence() {
      this.$emit('confirmClick');
      this.cities = [];
    },
    closeModalAgence() {
      this.$emit('closeClick');
      this.agencyNotFound = false;
       this.cities = [];
    }
  }
}
</script>

<style scoped>

</style>
